import type { UserData } from 'chaika-frontend-types/frontend-cms';

import { formatFullName } from '@utils/formatFullName';

export function getFullName(user: UserData): string {
    return formatFullName(user);
}
